export default {
    "dashboard.nav.dashboard": "Dashboard",
    "dashboard.nav.flashcards": "Flashcards",
    "dashboard.nav.quiz": "Quizzes",
    "dashboard.nav.audio": "Audio Summaries",
    "dashboard.nav.study_guide": "Study Guide",
    "dashboard.nav.exam": "Mock Exam",
    "dashboard.nav.stats": "Statistics",
    "dashboard.nav.settings": "Settings",
    "dashboard.nav.subscription": "Subscription",
    "dashboard.nav.logout": "Logout",
    "dashboard.nav.new_quiz": "New Quiz",

    "dashboard.welcome.title": "Hello, {{name}}!",
    "dashboard.welcome.description": "Pick up where you left off. Your next session is waiting.",
    "dashboard.welcome.last_activity": "Last activity: {{time}}",
    "dashboard.welcome.never": "Never",

    "dashboard.stats.completed_quiz": "Quizzes Completed",
    "dashboard.stats.progression": "Progression",
    "dashboard.stats.accuracy": "Accuracy",
    "dashboard.stats.to_review": "To Review",

    "dashboard.main.progression": "Global Progression",
    "dashboard.main.details": "View details",
    "dashboard.main.mastery": "Mastery",
    "dashboard.main.level": "Your Level",
    "dashboard.main.level_beginner": "Beginner",
    "dashboard.main.level_intermediate": "Intermediate",
    "dashboard.main.level_advanced": "Advanced",
    "dashboard.main.cta_continue": "Keep studying regularly to improve your retention.",
    "dashboard.main.total_answers": "Total Answers",
    "dashboard.main.correct_answers": "Correct Answers",
    "dashboard.main.current_streak": "Current Streak",

    "dashboard.badges.title": "My Badges",
    "dashboard.badges.count": "{{count}} badge",
    "dashboard.badges.count_plural": "badges unlocked",
    "dashboard.badges.empty": "Complete quizzes to unlock your first badges!",

    "dashboard.premium.title": "Go Premium!",
    "dashboard.premium.description": "Access all exclusive tools and content to maximize your chances of passing the exam.",
    "dashboard.premium.cta": "View offers",

    "dashboard.exam.title": "Mock Exam",
    "dashboard.exam.subtitle": "20 questions / 45 minutes",
    "dashboard.exam.description": "Simulate real conditions with a timed exam.",
    "dashboard.exam.cta": "Start an exam",

    "dashboard.activity.title": "Recent Activity",
    "dashboard.activity.empty": "No recent activity. Start a quiz!",
    "dashboard.activity.view_all": "View all history",
    "dashboard.activity.time_just_now": "Just now",
    "dashboard.activity.time_min": "{{count}} min ago",
    "dashboard.activity.time_hours": "{{count}} h ago",
    "dashboard.activity.time_yesterday": "Yesterday",
    "dashboard.activity.time_days": "{{count}} days ago",

    "dashboard.learning.title": "Learning Categories",
    "dashboard.learning.progression": "Progress",
    "dashboard.learning.flashcards": "Flashcards",
    "dashboard.learning.quiz": "Quiz",
    "dashboard.learning.unlock": "Unlock",
    "dashboard.learning.finished": "Finished",
    "dashboard.learning.pro": "PRO",

    "dashboard.payment.processing": "Activating your subscription...",
    "dashboard.payment.success_title": "Payment Successful!",
    "dashboard.payment.success_message": "Your subscription is now active. Enjoy all the features!"
};
